import { render } from "./SectionEight.vue?vue&type=template&id=8a00e056&scoped=true"
const script = {}

import "./SectionEight.vue?vue&type=style&index=0&id=8a00e056&lang=css&scoped=true"

import exportComponent from "/Users/konradfigura/Developer/first-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a00e056"]])

export default __exports__